import React from "react";
import { colors } from "@zapalacorp/tokens";

import { SvgWrapper } from "../styles";

interface SvgComponentProps {
  height?: number;
  width?: number;
  color?: string;
}

export function IconSidebar(props: SvgComponentProps) {
  const { width = 23, height = 23, color = colors.gray500 } = props;

  return (
    <SvgWrapper>
      <svg
        width={width}
        height={height}
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.0344 1.17188H8.40936C3.31874 1.17188 1.14374 3.34687 1.14374 8.4375L1.14374 14.0625C1.14374 19.1531 3.31874 21.3281 8.40936 21.3281H14.0344C19.125 21.3281 21.3 19.1531 21.3 14.0625V8.4375C21.3 3.34687 19.1344 1.17188 14.0344 1.17188ZM8.40936 19.9219C4.08749 19.9219 2.54999 18.3844 2.54999 14.0625L2.54999 8.4375C2.54999 4.11562 4.08749 2.57812 8.40936 2.57812H14.0344C18.3562 2.57813 19.8937 4.11562 19.8937 8.4375V14.0625C19.8937 18.3844 18.3562 19.9219 14.0344 19.9219H8.40936Z"
          fill={color}
        />
        <path
          d="M14.0344 1.17188C13.65 1.17188 13.3312 1.49063 13.3312 1.875L13.3312 20.625C13.3312 21.0094 13.65 21.3281 14.0344 21.3281C14.4187 21.3281 14.7375 21.0094 14.7375 20.625L14.7375 1.875C14.7375 1.49063 14.4281 1.17188 14.0344 1.17188Z"
          fill={color}
        />
        <path
          d="M7.47186 8.14687C7.29374 8.14687 7.11561 8.2125 6.97499 8.35312C6.70311 8.625 6.70311 9.075 6.97499 9.34687L8.87811 11.25L6.97499 13.1531C6.70311 13.425 6.70311 13.875 6.97499 14.1469C7.24686 14.4187 7.69686 14.4187 7.96874 14.1469L10.3687 11.7469C10.6406 11.475 10.6406 11.025 10.3687 10.7531L7.96874 8.35312C7.83749 8.2125 7.65936 8.14687 7.47186 8.14687Z"
          fill={color}
        />
      </svg>
    </SvgWrapper>
  );
}
